import { Pipe, PipeTransform } from '@angular/core';
import { EMPTY } from '@homeleite/common-utils';
import moment from 'moment';

@Pipe({
    name: 'detailedDate',
    standalone: false
})
export class DetailedDatePipe implements PipeTransform {
    transform(value: Date | moment.Moment | string): string {
        if (value == null) {
            return null;
        }

        const birthdate = moment(value);
        const today = moment();

        if (today.isSame(birthdate, 'day')) {
            return 'Recém-nascido';
        }

        const years = today.diff(birthdate, 'years');
        birthdate.add(years, 'years');

        const months = today.diff(birthdate, 'months');
        birthdate.add(months, 'months');

        const days = today.diff(birthdate, 'days');

        const parts = [
            this.formatPart(years, 'ano', 'anos'),
            this.formatPart(months, 'mês', 'meses'),
        years === 0 ? this.formatPart(days, 'dia', 'dias') : null
    ].filter((part) => part);

        if (parts.length === 0) {
            return 'Recém-nascido';
        }

        return parts.length > 1
            ? `${parts.slice(0, -1).join(', ')} e ${parts[parts.length - 1]}`
            : parts[0] || EMPTY;
    }

    private formatPart(value: number, singular: string, plural: string): string {
        return value > 0 ? `${value} ${value === 1 ? singular : plural}` : EMPTY;
    }
}

